/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'ngx-app',
  styleUrls: ['app.component.scss'],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private router: Router,
    private titleService: Title) {
  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();
    // this.seoService.trackCanonicalChanges();

    // this.router.routeReuseStrategy.shouldReuseRoute = () => {
    //   return false
    // }

    this.router.events.subscribe(val => {
      if (val instanceof NavigationEnd) {
        const title = val.url.includes('/admin') ? 'Admin Portal' : 'Tenant Portal'
        
        this.titleService.setTitle(title)
      }
    })
  }
}
